module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("PROLOGUE")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Nuevo Laredo, Mexico")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("G")])])])]), _vm._v("unfire echoed through the empty rooms of the abandoned house, making it seem as if a dozen shooters were involved, not just the two men who were exchanging fire in what had once been a luxurious den.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Suddenly a bullet slammed through an old, rusty barrel near the brick wall of the fireplace, igniting the few inches of gas still inside. Bounty hunter Wilson McKay saw the flash of ignition a second before the room went up in flames. He was on his feet and running when the blast from the explosion threw him out the door and onto his knees. He got up quickly and kept on running.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Solomon Tutuola was already ducking for cover when the room exploded. The force of the explosion threw him through a pair of windows at the south end of the house and out onto the ground.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("One moment he and Mark Presley had been in a run-and-gun fight with some tall, spiky-haired guy with an earring in his ear, and the next thing he knew, the house in which they had been hiding went up in smoke.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For a few seconds Tutuola lay faceup outside, staring into the sun, all but immobile from the force of the blast. He drew a shallow breath, then another and another. Suddenly a white-hot shaft of searing pain brought him to a sitting position as shock subsided and agony took its place. Groaning and shaking from the shock waves, he rolled over onto his hands and knees, and began crawling away from the burning house, dodging fiery debris, convinced that the skin was melting off his face. He passed out about a hundred yards from the house, unaware that Mark Presley, the man he’d chauffeured into Mexico, had been captured and the two bounty hunters who’d come after him were long gone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When Solomon came to, hours later, it was late afternoon and he was in more misery than he’d ever felt in his life. He heard the soft sounds of a four-legged animal trotting around his head, then his feet. He opened his eyes, horrified to find a coyote nosing at his heels, while a trio of buzzards circled overhead.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The roar that came out of his throat sent the coyote packing. Solomon staggered to his feet, then turned around, staring first at the smoldering embers of the hacienda, then down at his hands. Blisters had formed on the burns, then burst, mixing with the dirt on which he’d been lying. His entire body was shaking from the intensity of his pain. It wasn’t until he tried to blink that he realized he couldn’t see out of his left eye, and when he lifted his fingers to that side of his face, he screamed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Son of a bitch!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The flesh that came away at his touch was blackened and bloody, and there was a part of his head that was completely devoid of hair. As best he could tell, the entire left side of his face and head had been seriously burned. He needed to get to a doctor, and fast. If he didn’t die from the pain, he was damn sure going to die from infection.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cursing and screaming with every step he took, Solomon made it to his car. The keys were still in the ignition, and Mark Presley’s luggage—a large duffle bag and a wheeled overnighter—was still on the backseat.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Without wasting time wondering what had happened to Mark, he started the car and headed for Nuevo Laredo.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("By nightfall, he was in the hospital, under sedation. The bags were locked in the trunk of his car. His car keys were in his burned pants, hanging in the tiny closet with what was left of the shirt he’d been wearing. Every few minutes, a nurse came into his room, checked the saline solution laced with morphine being pumped into his body, making sure that he wasn’t losing more fluids than were being replaced. For all intents and purposes, Solomon Tutuola was teetering on the verge of death.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07b8de27","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter-01.vue
// module id = 69
// module chunks = 0